import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { mailingListSchema, mailingListsSchema } from '../../../store/schema';
import {
  createMailingListSuccess,
  deleteMailingListSuccess,
  fetchAllMailingListsSuccess,
  updateMailingListSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { getEntities } from '../../../store/entities/selectors';


const fetchAll = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.mailingLists.fetchAll().pipe(
    map((response) => normalize(response.body, mailingListsSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllMailingListsSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const createMailingList = (action$, state$) => action$.pipe(
  ofType(actionTypes.CREATE),
  switchMap((action) => {
    const mailingList = denormalize(
      action.mailingList, mailingListSchema, getEntities(state$.value),
    );
    return api.mailingLists.create(mailingList).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, mailingListSchema);
        return [
          entitiesFetchSuccess(entities),
          createMailingListSuccess(response.body),
        ];
      }),
      catchError((error) => [handleError(error)]),
    );
  }),
);


const updateMailingList = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) => {
    const mailingList = denormalize(
      action.mailingList, mailingListSchema, getEntities(state$.value),
    );
    return api.mailingLists.update(mailingList).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, mailingListSchema);
        return [
          entitiesFetchSuccess(entities),
          updateMailingListSuccess(action.mailingList.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    );
  }),
);


const deleteMailingList = (action$) => action$.pipe(
  ofType(actionTypes.DELETE),
  switchMap((action) => api.mailingLists.delete(action.mailingList).pipe(
    mergeMap(() => [
      deleteMailingListSuccess(action.mailingList.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

export default combineEpics(
  fetchAll,
  createMailingList,
  updateMailingList,
  deleteMailingList,
);
